import { render, staticRenderFns } from "./2.vue?vue&type=template&id=19a40e03&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19a40e03')) {
      api.createRecord('19a40e03', component.options)
    } else {
      api.reload('19a40e03', component.options)
    }
    module.hot.accept("./2.vue?vue&type=template&id=19a40e03&", function () {
      api.rerender('19a40e03', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/add-routes/alternates/2.vue"
export default component.exports